@if (brand?.logo?.resource || brand?.name) {
<section class="brand">
  <h3>{{ brand?.name }}</h3>
  <planone-profile-picture>
    @if (brand?.logo?.resource) {
    <img
      [src]="
        brand?.logo?.resource
          | ImageUrl : brand?.logo?.provider : { width: 60, height: 60, fileType: ImageFileTypes.WEBP }
      "
      [alt]="brand?.name"
      class="brand__logo" />
    } @else {
    <mat-icon class="brand__logo-placeholder">shoppingmode</mat-icon>
    }
  </planone-profile-picture>
</section>
}
